import { useEffect } from "react";
import { Link } from "react-router-dom";
import { endPoints, siteConfig } from "../../../config/end-points";
import { FiArrowLeft } from "react-icons/fi";
import "../legal.css";

const TermsOfService = () => {
  useEffect(() => {
    document.title = `${endPoints.title} | Terms of Service`;
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/login" className="legal-back">
          <FiArrowLeft size={16} /> Back to Login
        </Link>

        <div className="legal-header">
          <img src={endPoints.logo} alt={endPoints.title} className="legal-logo" />
          <h1>Terms of Service</h1>
          <p className="legal-updated">Last updated: March 18, 2026</p>
        </div>

        <div className="legal-content">
          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              By accessing and using {siteConfig.title} ("the Platform"), you agree to be bound by
              these Terms of Service. If you do not agree to these terms, please do not use the Platform.
            </p>
          </section>

          <section>
            <h2>2. Description of Service</h2>
            <p>
              {siteConfig.title} is an AI-powered website building platform that allows users to create,
              manage, and publish websites. The Platform provides tools for generating website content,
              managing site structures, and deploying websites to custom domains.
            </p>
          </section>

          <section>
            <h2>3. User Accounts</h2>
            <p>
              You are responsible for maintaining the confidentiality of your account credentials and for
              all activities that occur under your account. You agree to notify us immediately of any
              unauthorized use of your account.
            </p>
          </section>

          <section>
            <h2>4. Acceptable Use</h2>
            <p>You agree not to use the Platform to:</p>
            <ul>
              <li>Create websites that contain illegal, harmful, or offensive content</li>
              <li>Violate any applicable local, national, or international laws</li>
              <li>Infringe on any third-party intellectual property rights</li>
              <li>Distribute malware, spam, or engage in phishing activities</li>
              <li>Attempt to gain unauthorized access to the Platform or its systems</li>
              <li>Use the Platform for any fraudulent or deceptive purposes</li>
            </ul>
          </section>

          <section>
            <h2>5. Content Ownership</h2>
            <p>
              You retain ownership of the content you create using the Platform. However, you grant
              {siteConfig.title} a non-exclusive license to host, display, and distribute your content
              as necessary to provide the service. You are solely responsible for all content created
              using your account.
            </p>
          </section>

          <section>
            <h2>6. AI-Generated Content</h2>
            <p>
              The Platform uses artificial intelligence to assist in content generation. While we strive
              for accuracy, AI-generated content may contain errors or inaccuracies. You are responsible
              for reviewing and verifying all AI-generated content before publishing.
            </p>
          </section>

          <section>
            <h2>7. Account Termination</h2>
            <p>
              We reserve the right to suspend or terminate your account at any time if you violate
              these Terms of Service. Upon termination, your right to use the Platform will immediately
              cease, and we may delete your account data.
            </p>
          </section>

          <section>
            <h2>8. Limitation of Liability</h2>
            <p>
              {siteConfig.title} is provided "as is" without warranties of any kind. We shall not be
              liable for any indirect, incidental, special, or consequential damages arising from your
              use of the Platform.
            </p>
          </section>

          <section>
            <h2>9. Changes to Terms</h2>
            <p>
              We may update these Terms of Service from time to time. We will notify you of any
              significant changes by posting the new terms on the Platform. Your continued use of the
              Platform after changes are posted constitutes your acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2>10. Contact</h2>
            <p>
              If you have any questions about these Terms of Service, please contact us through the
              Platform's support channels.
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <p>{siteConfig.copyright}</p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
